/**
 * The role the app SHOWS, given the role the server GRANTS and the one the person picked in
 * Settings. Acting down is a view (a manager checking what a purchaser's board looks like — the
 * board then scopes to their own enquiries, like a purchaser's); acting up is not a thing, so a
 * choice above the granted role is ignored. `null` granted means the server has not answered
 * (offline, the mock): the choice stands, purchaser by default.
 */
import type { Role } from './types'

const RANK: Record<Role, number> = { sales: 0, purchaser: 1, purchase_manager: 2 }

export function effectiveRole(granted: Role | null, chosen: Role | null): Role {
  if (granted === null) return chosen ?? 'purchaser'
  if (chosen === null) return granted
  return RANK[chosen] < RANK[granted] ? chosen : granted
}

/** The roles a person may act as: their own and anything below it. */
export function actableRoles(granted: Role | null, all: readonly Role[]): Role[] {
  if (granted === null) return [...all]
  return all.filter((r) => RANK[r] <= RANK[granted])
}
